import { render, staticRenderFns } from "./Pte.vue?vue&type=template&id=6cffdea8&scoped=true&"
import script from "./Pte.vue?vue&type=script&lang=js&"
export * from "./Pte.vue?vue&type=script&lang=js&"
import style0 from "./Pte.vue?vue&type=style&index=0&id=6cffdea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cffdea8",
  null
  
)

export default component.exports